<script setup>
import {ref, onMounted, computed, inject, getCurrentInstance} from 'vue'
import { useRouter } from 'vue-router'
import SNB from '../../../../../layouts/nav/SNB.vue'
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import {useMyPageLectDetailStore} from "../../../stores/mypage/mypageLectDetailStore";
import _ from 'lodash'
import moment from "moment/moment";
import jobFairUserService from "../../../../user/services/jobFair/jobFairUserService";
import { useAlertStore } from '../../../../../stores/alertStore';
const { $alert, $confirm } = useAlertStore();

const globals = getCurrentInstance().appContext.config.globalProperties;
const { $gbNameKR, $pageListBoardNo } = globals;

const router = useRouter()
const loadingStore = usePageLoadingStore()
const lectureStore = useMyPageLectDetailStore()

const list = ref([]);
const listIng = ref([]);
const currentPage = ref(1);
const pageSize = 30;
const totalPages = ref(1);
const totalCount = ref(0);

// 채용박람회 현황 옵션
const joinStateGb = ref('');
const joinStateGbList = [
  { label:"전체", value: "01,02,03,04,11,21" },
  { label:"신청 접수 완료", value: "01" },
  { label:"신청 검토중", value: "02" },
  { label:"신청 취소", value: "03,04" },
  { label:"승인(참가확정)", value: "11" },
  { label:"반려(참가불가)", value: "21" },
];

// 채용박람회 현황 탭
const ojfStateGbOptionTab = ref('01,02,04');
const ojfStateGbOptions = ref([
  {label:'전체', value:'01,02,04'}, // 01: 신청 접수중, 02: 신청 마감, 04: 행사 종료
  {label:'진행중', value:'03'}, // 03: 행사 진행중
  {label:'종료', value:'04'} // 04: 행사종료
])

onMounted(() => {
  retrieveList();
  retrieveListIng();
})

const retrieveList = async () => {
  let paramObj = {
    searchOjfStateGb: ojfStateGbOptionTab.value || "01,02,04",
    searchJoinStateGb: joinStateGb.value || "01,02,03,04,11,21",
    ojfGb: "02",
    pageNumber: currentPage.value || 0,
    size: pageSize.value || 30,
  }

  // loadingStore.loading = true;
  jobFairUserService.ojfListByUserId(paramObj)
      .then( (res) => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = result.content;
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}

// 진행중 데이터
const retrieveListIng = async () => {
  let paramObj = {
    searchOjfStateGb: "03",
    searchJoinStateGb: joinStateGb.value || "01,02,03,04,11,21",
    ojfGb: "02",
    pageNumber: 0,
    size: 100,
  }
  // loadingStore.loading = true;

  jobFairUserService.ojfListByUserId(paramObj)
      .then( (res) => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          listIng.value = result.content;
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}

// 전체, 진행중, 종료
const onChangeTab = (option) => {
  ojfStateGbOptionTab.value = option.value;
  retrieveList();
}

// 채용박람회 현황 옵션 선택
const onSelectEmployStateGb = (option) => {
  joinStateGb.value = option.value;
  retrieveList();
  retrieveListIng();
}

// 페이지 클릭
const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveList();
  retrieveListIng();
}

// 채용박람회 상세 페이지 이동
const goSpecialEmployDetailView = (ojfId, joinStateGb) => {
  if (joinStateGb === '03' || joinStateGb === '04') {
    $alert("신청 취소된 행사입니다.");
  } else {
    router.push({name: 'MyPageJobFairDetail', params:{id: ojfId}})
  }
}

// 채용박람회 썸네일 이미지 기간별 class name
const employImgClass = (employ) => {
  const regStartYmd = moment(employ.regStartYmd.replaceAll('.', '')).format('YYYYMMDD');
  const regEndYmd = moment(employ.regEndYmd.replaceAll('.', '')).format('YYYYMMDD');
  const ojfStartYmd = moment(employ.ojfStartYmd.replaceAll('.', '')).format('YYYYMMDD');
  const ojfEndYmd = moment(employ.ojfEndYmd.replaceAll('.', '')).format('YYYYMMDD');
  const nowYmd = moment().format('YYYYMMDD');

  const { $isInRegPeriod } = getCurrentInstance().appContext.config.globalProperties;
  const { $isAfterRegEnd } = getCurrentInstance().appContext.config.globalProperties;

  if(employ.ojfStateGb === '00') {
    return 'waiting';
  } else if(employ.ojfStateGb === '01') {
    return 'app-open';
  } else if (employ.ojfStateGb === '02') {
    return 'app-close';
  } else if (employ.ojfStateGb === '03') {
    if ($isInRegPeriod(employ.regStartYmd, employ.regEndYmd)) {
      return 'event-ongoing';
    } else if ($isAfterRegEnd(employ.regEndYmd)) {
      return 'event-closed';
    } else {
      return 'event-open';
    }
  } else if (employ.ojfStateGb === '04') {
    return 'event-close';
  } else  {
    return '';
  }
}
</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB class="snb" />
        <div class="content">
          <div class="lecture-wrap">
            <div class="sub-title">
              <h3>채용박람회 현황</h3>
            </div>
            <div class="content-title grid space-between">
              <KSATab class="tab-style_small" :options="ojfStateGbOptions" @change="onChangeTab"/>
              <KSASelect :options="joinStateGbList" class="select" @selectOption="onSelectEmployStateGb"/>
            </div>
            <!-- S: 진행중 -->
            <ul class="lecture-list" v-if="ojfStateGbOptionTab === '03' || ojfStateGbOptionTab === '01,02,04'">
              <li v-for="employIng in listIng" @click="goSpecialEmployDetailView(employIng.ojfId, employIng.joinStateGb)">
                <div class="lecture-img" :class="employImgClass(employIng)">
                  <KSAImage :src="employIng.ojfThombDir"/>
                </div>
                <div class="lecture-text">
                  <span class="badge" :class="{'jobstate1': (employIng.joinStateGb === '03' || employIng.joinStateGb === '04'), 'jobstate2': employIng.joinStateGb === '01', 'jobstate3': employIng.joinStateGb === '02', 'jobstate4': employIng.joinStateGb === '11', 'jobstate5': employIng.joinStateGb === '21'}">
                      {{ $gbNameKR('USER_JOIN_STATE_GB', employIng.joinStateGb) }}
                  </span>
                  <h4>{{ employIng.ojfName }}</h4>
                  <div class="lecture-info">
                    <p class="date">
                      <i>
                        <b>접수기간</b>
                        <span>
                          {{ $yyyymmdd(employIng.regStartYmd) }} ({{ $dateToWeekDayShort(employIng.regStartYmd) }})
                          ~
                          {{ $yyyymmdd(employIng.regEndYmd) }} ({{ $dateToWeekDayShort(employIng.regEndYmd) }})
                        </span>
                      </i>
                    </p>
                    <p class="date">
                      <i>
                        <b>행사기간</b>
                        <span>
                          {{ $yyyymmdd(employIng.ojfStartYmd) }} ({{ $dateToWeekDayShort(employIng.ojfStartYmd) }})
                          ~
                          {{ $yyyymmdd(employIng.ojfEndYmd) }} ({{ $dateToWeekDayShort(employIng.ojfEndYmd) }})
                        </span>
                      </i>
                    </p>
                    <p class="date">
                      <i>
                        <b>장소</b>
                        <span>{{ employIng.ojfPlace }}</span>
                      </i>
                    </p>
                    <p class="date">
                      <i>
                        <b>주최</b>
                        <span>{{ employIng.ojfHost }}</span>
                      </i>
                    </p>
                  </div>
                </div>
              </li>
            </ul>
            <!-- E: 진행중 -->
            <!-- S: 전체 -->
            <ul class="lecture-list"
                :style="( ['04','01,02,04'].includes(ojfStateGbOptionTab) && list.length === 0 )
                ? { borderBottom: '0' }
                : {}"
                v-if="ojfStateGbOptionTab === '04' || ojfStateGbOptionTab === '01,02,04'">
              <li v-for="employ in list" @click="goSpecialEmployDetailView(employ.ojfId, employ.joinStateGb)">
                <div class="lecture-img" :class="employImgClass(employ)">
                  <KSAImage :src="employ.ojfThombDir"/>
                </div>
                <div class="lecture-text">
                  <span class="badge" :class="{'jobstate1': (employ.joinStateGb === '03' || employ.joinStateGb === '04'), 'jobstate2': employ.joinStateGb === '01', 'jobstate3': employ.joinStateGb === '02', 'jobstate4': employ.joinStateGb === '11', 'jobstate5': employ.joinStateGb === '21'}">
                      {{ $gbNameKR('USER_JOIN_STATE_GB', employ.joinStateGb) }}
                  </span>
                  <h4>{{ employ.ojfName }}</h4>
                  <div class="lecture-info">
                    <p class="date">
                      <i>
                        <b>접수기간</b>
                        <span>
                          {{ $yyyymmdd(employ.regStartYmd) }} ({{ $dateToWeekDayShort(employ.regStartYmd) }})
                          ~
                          {{ $yyyymmdd(employ.regEndYmd) }} ({{ $dateToWeekDayShort(employ.regEndYmd) }})
                        </span>
                      </i>
                    </p>
                    <p class="date">
                      <i>
                        <b>행사기간</b>
                        <span>
                          {{ $yyyymmdd(employ.ojfStartYmd) }} ({{ $dateToWeekDayShort(employ.ojfStartYmd) }})
                          ~
                          {{ $yyyymmdd(employ.ojfEndYmd) }} ({{ $dateToWeekDayShort(employ.ojfEndYmd) }})
                        </span>
                      </i>
                    </p>
                    <p class="date">
                      <i>
                        <b>장소</b>
                        <span>{{ employ.ojfPlace }}</span>
                      </i>
                    </p>
                    <p class="date">
                      <i>
                        <b>주최</b>
                        <span>{{ employ.ojfHost }}</span>
                      </i>
                    </p>
                  </div>
                </div>
              </li>
            </ul>
            <div class="result-none lecture-none" v-if="(list.length === 0 && listIng.length === 0) || (ojfStateGbOptionTab === '04' && list.length === 0) || (ojfStateGbOptionTab === '01,02,03' && listIng.length === 0)">
              검색 결과가 없습니다.
            </div>
            <!-- E: 전체 -->
          </div>
        </div>
      </div>
      <Paginate
          v-if="list.length > 0"
          v-model="currentPage"
          :page-count="totalPages"
          :click-handler="onSelectPage"
      />
    </div>
  </div>
</template>


<style lang="scss" scoped>
.lecture-wrap {
  .content-title {
    font-weight: normal;
    .select {
      width: 166px;
    }
  }
  .lecture-list {
    &:first-of-type {
      margin-bottom: 40px;
    }
  }
}
</style>
